import { render, staticRenderFns } from "./SoilECIcon.vue?vue&type=template&id=01400e4f"
import script from "./SoilECIcon.vue?vue&type=script&lang=js"
export * from "./SoilECIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports